import 'url-search-params-polyfill';
import { useEffect } from "react";

export const TradingtrendPreview = (props) => {
    useEffect(() => {
        const container = document.getElementById('tradingview-widget');

        if (container) {
            container.innerHTML = ''; // Limpiar el contenedor

            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                interval: "1m",
                width: "100%",
                height: props.height || "450",
                symbol: props?.symbol,
                showIntervalTabs: true,
                displayMode: "single",
                locale: "en",
                colorTheme: "light",
                isTransparent: false,
            });

            container.appendChild(script);
        }

        return () => {
            // Limpia el contenedor al desmontar o actualizar
            if (container) {
                container.innerHTML = '';
            }
        };
    }, [props?.symbol]);

    return (
        <div className="tradingview-widget-container">
            <div id="tradingview-widget" className="tradingview-widget-container__widget"></div>
        </div>
    );
};
